function MainPage() {
 return (
  <>
   <h1>You are logged</h1>
  </>
 )
}

export default MainPage
